var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { useSetAtom } from 'jotai';
import { Translate } from "../../I18N";
import { notificationAtom } from "../atoms";







const getData = async (res) => res.json ? res.json() : res;
const getError = async (res) => {
  const json = res.json ? await res.json() : undefined;
  return json && json.error ? json.error : new Error('An error occurred');
};

const useApiCaller = () => {
  const setNotifications = useSetAtom(notificationAtom);

  const handleSuccess = async (res, successMessageComponent) => {
    setNotifications({
      type: 'success',
      text: successMessageComponent
    });
    return getData(res);
  };

  const handleError = async (e) => {var _e$json;
    setNotifications({
      type: 'error',
      text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
      details: (_e$json = e.json) !== null && _e$json !== void 0 && _e$json.prettyMessage ? /*#__PURE__*/_jsx("span", {}, void 0, e.json.prettyMessage) : undefined
    });
    return e.message;
  };

  const requestAction = async (
  action,
  requestParams,
  successMessageComponent) =>
  {
    let data;
    let error;
    try {
      const res = await action(requestParams);
      if (!res.status || res.status === 200) {
        data = handleSuccess(res, successMessageComponent);
      } else {
        error = handleError(await getError(res));
      }
    } catch (e) {
      error = handleError(e);
    }
    const result1 = { data, error: Promise.resolve(error) };
    return result1;
  };

  return { requestAction };
};


export { useApiCaller };